import * as z from "zod";
import { CUSTOM_ANALYTICS_SEMANTIC_QUERY_VERSION } from "../semantic-queries/v1/analytics-query/analytics-query-constants";
import { CustomAnalyticsSemanticQuerySchema } from "../semantic-queries/v1/analytics-query/analytics-query-schema";
import type { CustomAnalyticsSemanticQuery } from "../semantic-queries/v1/analytics-query/analytics-query-types";
import { ANALYTICS_QUERY_VERSION } from "./v2/analytics-query/analytics-query-constants";
import { AnalyticsQuerySchema } from "./v2/analytics-query/analytics-query-schema";
import type { AnalyticsQuery } from "./v2/analytics-query/analytics-query-types";

export const CustomAnalyticsQueryVersion = {
  V1: CUSTOM_ANALYTICS_SEMANTIC_QUERY_VERSION,
  V2: ANALYTICS_QUERY_VERSION,
} as const;

export type CustomAnalyticsQueryVersion =
  (typeof CustomAnalyticsQueryVersion)[keyof typeof CustomAnalyticsQueryVersion];

export const CustomAnalyticsQueryVersionSchema = z.union([
  z.literal(CustomAnalyticsQueryVersion.V1),
  z.literal(CustomAnalyticsQueryVersion.V2),
]);

export const CURRENT_CUSTOM_ANALYTICS_QUERY_VERSION: CustomAnalyticsQueryVersion =
  CustomAnalyticsQueryVersion.V1;

export type CustomAnalyticsReportQuery =
  | CustomAnalyticsSemanticQuery
  | AnalyticsQuery;

/** v1 rows written before the version field existed parse as v1. */
export const CustomAnalyticsReportQuerySchema: z.ZodType<CustomAnalyticsReportQuery> =
  z.union([CustomAnalyticsSemanticQuerySchema, AnalyticsQuerySchema]);
